"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _uuid = require("uuid");
var _coreThemes = require("@vfuk/core-themes");
var _coreContainer = _interopRequireDefault(require("@vfuk/core-container"));
var _coreBaseProps = require("@vfuk/core-base-props");
var Styled = _interopRequireWildcard(require("./styles/Accordion.style"));
var _Accordion2 = _interopRequireDefault(require("./themes/Accordion.theme"));
var _hooks = _interopRequireDefault(require("./hooks"));
var _excluded = ["appearance", "id", "children", "multi", "level", "localTheme", "dataSelectorPrefix", "dataAttributes"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var Accordion = function Accordion(_ref) {
  var _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
    id = _ref.id,
    children = _ref.children,
    multi = _ref.multi,
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? 1 : _ref$level,
    localTheme = _ref.localTheme,
    dataSelectorPrefix = _ref.dataSelectorPrefix,
    dataAttributes = _ref.dataAttributes,
    props = _objectWithoutProperties(_ref, _excluded);
  var componentName = 'Accordion';
  var accordionTheme = (0, _coreThemes.useLocalTheme)(componentName, _Accordion2["default"], localTheme);
  var _accordionTheme$appea = accordionTheme.appearance[appearance],
    containerAppearance = _accordionTheme$appea.containerAppearance,
    inverseCollapsibleContainer = _accordionTheme$appea.inverseCollapsibleContainer;
  var _ref2 = props,
    onToggle = _ref2.onToggle,
    controlledOpenIds = _ref2.openIds;
  var isControlled = (0, _react.useMemo)(function () {
    return !!controlledOpenIds && !!onToggle;
  }, [controlledOpenIds, onToggle]);
  var _ref3 = props,
    initiallyOpenIds = _ref3.initiallyOpenIds;
  var _useAccordion = (0, _hooks["default"])({
      initiallyOpenIds: initiallyOpenIds,
      multi: multi
    }),
    defaultOpenIds = _useAccordion.openIds,
    defaultOnToggle = _useAccordion.onToggle;
  var uniqueId = (0, _react.useMemo)(function () {
    return (0, _uuid.v4)();
  }, []);
  var onToggleHandler = (0, _react.useMemo)(function () {
    return isControlled ? onToggle : defaultOnToggle;
  }, [isControlled, onToggle, defaultOnToggle]);
  var openIds = (0, _react.useMemo)(function () {
    return isControlled ? controlledOpenIds : defaultOpenIds;
  }, [isControlled, controlledOpenIds, defaultOpenIds]);
  return /*#__PURE__*/_react["default"].createElement(Styled.Accordion, _extends({
    id: id,
    level: level,
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix),
    "data-component-name": componentName
  }, dataAttributes), _react.Children.map(children, function (child, index) {
    var _child$props$id;
    var collapsibleContainerId = (_child$props$id = child.props.id) !== null && _child$props$id !== void 0 ? _child$props$id : "".concat(uniqueId, "-").concat(index);
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: collapsibleContainerId
    }, level === 1 ? /*#__PURE__*/_react["default"].createElement(_coreContainer["default"], {
      key: collapsibleContainerId,
      elevation: true,
      appearance: containerAppearance,
      dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "container-".concat(index))
    }, /*#__PURE__*/(0, _react.cloneElement)(child, {
      id: collapsibleContainerId,
      isActive: openIds.includes(collapsibleContainerId),
      onToggle: function onToggle() {
        return onToggleHandler(collapsibleContainerId);
      },
      inverse: inverseCollapsibleContainer
    })) : /*#__PURE__*/(0, _react.cloneElement)(child, {
      key: index,
      id: collapsibleContainerId,
      isActive: openIds.includes(collapsibleContainerId),
      onToggle: function onToggle() {
        return onToggleHandler(collapsibleContainerId);
      },
      inverse: inverseCollapsibleContainer
    }));
  }));
};
Accordion.displayName = "Accordion";
var _default = Accordion;
exports["default"] = _default;